import { Story } from '../../types/story';

export const madridAfterMidnight: Story = {
  id: 'madrid-after-midnight',
  title: 'After Midnight',
  excerpt: 'In a city that never sleeps, two men find each other in the crowd and discover that some connections transcend language.',
  city: 'Madrid',
  publishDate: '2025-12-24',
  readTime: '14 min read',
  tags: ['♂♂', 'passionate', 'nightlife', 'language barrier'],
  categories: ['queer', 'intense'],
  intensity: 3,
  content: `Madrid doesn't really start until midnight. That's what my colleague had told me before I arrived, and I'd laughed, thinking it was an exaggeration. But here I was at 1 AM, and the streets were more alive than they'd been at dinner time.

I'd ducked into a bar to escape the crowds—or so I told myself. Really, I was looking for something, though I couldn't quite name what. The bar was small and packed, with music so loud you could feel it in your chest. I ordered a gin and tonic and found a spot against the wall where I could watch.

That's when I saw him.

He was dancing with a group of friends, completely unselfconscious, moving with the kind of easy grace that made it impossible to look away. Dark hair, sharp jawline, a white shirt with the sleeves rolled up. When he laughed at something his friend said, his whole face lit up.

Our eyes met across the room, and something passed between us—recognition, maybe, or just possibility. He said something to his friends and started making his way through the crowd toward me.

"Hola," he said when he reached me, and even that one word sounded like music.

"Hi." I smiled. "I don't speak much Spanish."

"Is okay. I speak little English." His accent was thick but charming. "You are tourist?"

"Here for work. You?"

"I live here." He gestured around the bar. "This is my neighborhood. You like Madrid?"

"I'm starting to."

He grinned, and I noticed the way his eyes crinkled at the corners. "You want to dance?"

I wasn't much of a dancer, but I found myself nodding. He took my hand and led me into the crowd, and suddenly we were pressed together, moving to the rhythm of the music. His hand was on my lower back, pulling me closer, and I could smell his cologne—something woody and warm.

We danced for what felt like hours, though it was probably only twenty minutes. The music shifted from reggaeton to something slower, and he leaned in close, his lips brushing my ear.

"You want to go somewhere more quiet?"

My heart was racing. "Yes."

Outside, the air was warm and still. He led me through narrow streets, past closed shops and late-night cafés, until we reached a small plaza with a fountain in the center. We sat on the edge of it, and he offered me a cigarette, which I declined.

"What is your name?" he asked.

"James. You?"

"Mateo." He held out his hand formally, and I shook it, both of us laughing at the absurdity of introducing ourselves now.

"So, Mateo. What do you do when you're not dancing in bars?"

He struggled for the words. "I work in... how you say... restaurant. I am chef."

"A chef? That's impressive."

He shrugged modestly. "Is okay. I like to cook. You? What is your work?"

"I'm a consultant. Very boring compared to being a chef."

"No, no boring." He shifted closer, his thigh pressing against mine. "You are interesting. I can tell."

"How can you tell?"

"Your eyes. They see everything. You watch people."

He was right, and it surprised me that he'd noticed. "You're very observant for someone who just met me."

"I notice beautiful things." His hand found mine, and he traced the lines of my palm with his finger. "Is okay I say this?"

"It's more than okay."

We sat there for a while, talking in our broken shared language, filling in the gaps with gestures and smiles. He told me about growing up in Madrid, about his family's restaurant in Andalusia, about his dreams of opening his own place someday. I told him about my life in London, about how I'd been feeling restless lately, like I was living someone else's life.

"Sometimes we need to be lost," he said thoughtfully. "To find what we really want."

"Is that what you think I am? Lost?"

"Maybe. But is okay. I find you." He smiled and leaned in, his lips meeting mine.

The kiss was soft at first, exploratory, but it quickly deepened. His hand came up to cup the back of my neck, and I pulled him closer, tasting the cigarettes and gin on his tongue. When we finally broke apart, we were both breathing hard.

"My apartment is close," he said. "You want to come?"

I should have said no. I should have been sensible, should have remembered that I had a meeting at 9 AM, should have thought about all the reasons this was a bad idea.

Instead, I said yes.

His apartment was on the fourth floor of an old building with no elevator. By the time we reached his door, we were both laughing and out of breath. Inside, it was small but cozy—a kitchen that clearly belonged to someone who loved to cook, a living room with mismatched furniture, a bedroom with the door half-open.

He poured us wine, and we stood in his tiny kitchen, talking and kissing in equal measure. His hands were everywhere—in my hair, on my face, sliding under my shirt. I'd never felt so wanted, so desired.

"Bedroom?" he asked, and I nodded.

What happened next was a blur of sensation—clothes being removed, skin against skin, his mouth on my neck, my hands exploring the planes of his body. He was confident and attentive, somehow knowing exactly what I needed even without words.

"Tell me," he whispered at one point, his hand pausing. "What you like?"

"This," I managed. "Don't stop."

He didn't. He took his time, building the pleasure slowly until I was trembling beneath him. When I finally came, I called out his name, and he kissed me through it, swallowing my moans.

Afterward, we lay tangled together, his head on my chest, both of us catching our breath.

"You stay?" he asked sleepily.

"I have to leave early. Meeting."

"Is okay. I make you breakfast before you go. Is the least I can do for beautiful stranger."

I smiled in the darkness. "That sounds perfect."

I woke to the smell of coffee and something cooking. Mateo was in the kitchen, wearing only boxer briefs, humming as he worked. He'd made tortilla española and fresh bread, and we ate together as the sun rose over Madrid.

"You come back to Madrid?" he asked as I was getting ready to leave.

"Maybe. Probably."

He wrote his number on a piece of paper and pressed it into my hand. "You call me. We do this again, yes?"

"Yes," I said, and kissed him one more time.

I never did call. Not because I didn't want to, but because some moments are perfect in their singularity. But sometimes, late at night, I think about Mateo and his small apartment and the way he made me feel like I was exactly where I was supposed to be. And I smile.`
};
